<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="page-content">

  <h1>{{getString("notificationSettings")}}</h1>

  <div class="form-container">

    <app-spinner *ngIf="isLoading" class="loading-spinner"></app-spinner>

      <div class="cb-container">
        <app-toggle-switch [checked]="emailNotificationsOn" [label]="getString('emailNotifications')" (onChange)="emailNotificationChanged($event)"></app-toggle-switch>
        <div class="cb-desc">{{getString('emailNotificationsText')}}</div>
      </div>

      <div class="cb-container">
        <app-custom-checkbox [value]="wishlistOn" [enabled]="emailNotificationsOn" [label]="getString('wishlist')" (onChange)="wishlistChanged($event)"></app-custom-checkbox>
        <div class="cb-desc">{{getString('wishlistNotificationsText')}}</div>
      </div>

      <div class="cb-container">
        <app-custom-checkbox [value]="blogPostsOn" [enabled]="emailNotificationsOn" [label]="getString('blogPosts')" (onChange)="blogPostsChanged($event)"></app-custom-checkbox>
        <div class="cb-desc">{{getString('blogPostsNotificationsText')}}</div>
      </div>
    
      <div class="cb-container">
        <app-custom-checkbox [value]="commentsOn" [enabled]="emailNotificationsOn" [label]="getString('comments')" (onChange)="commentsChanged($event)"></app-custom-checkbox>
        <div class="cb-desc">{{getString('commentsNotificationsText')}}</div>
      </div>

      <div class="cb-container">
          <app-custom-checkbox [value]="cardDealsOn" [enabled]="emailNotificationsOn" [label]="getString('cardDeals')" (onChange)="cardDealsChanged($event)"></app-custom-checkbox>
          <div class="cb-desc">{{getString('cardDealsNotificationsText')}}</div>
        </div>

      <div class="cb-container">
        <app-custom-checkbox [value]="otherDealsOn" [enabled]="emailNotificationsOn" [label]="getString('otherDeals')" (onChange)="otherDealsChanged($event)"></app-custom-checkbox>
      </div>

    <table>
      <tr>
        <td class="half">
          <app-custom-checkbox [value]="musicOn" [enabled]="emailNotificationsOn" [label]="getString('music')" (onChange)="mediaChanged($event, 'music')"></app-custom-checkbox>
        </td>
        <td class="half">
          <app-custom-checkbox [value]="audiobooksOn" [enabled]="emailNotificationsOn" [label]="getString('audiobooks')" (onChange)="mediaChanged($event, 'audiobooks')"></app-custom-checkbox>
        </td>
      </tr>

      <tr>
        <td class="half">
          <app-custom-checkbox [value]="moviesOn" [enabled]="emailNotificationsOn" [label]="getString('movies')" (onChange)="mediaChanged($event, 'movies')"></app-custom-checkbox>
        </td>
        <td class="half">
          <app-custom-checkbox [value]="ebooksOn" [enabled]="emailNotificationsOn" [label]="getString('ebooks')" (onChange)="mediaChanged($event, 'ebooks')"></app-custom-checkbox>
        </td>
      </tr>

      <tr>
        <td class="half">
          <app-custom-checkbox [value]="seasonsOn" [enabled]="emailNotificationsOn" [label]="getString('seasons')" (onChange)="mediaChanged($event, 'seasons')"></app-custom-checkbox>
        </td>
        <td class="half">
          <app-custom-checkbox [value]="appsOn" [enabled]="emailNotificationsOn" [label]="getString('apps')" (onChange)="mediaChanged($event, 'apps')"></app-custom-checkbox>
        </td>
      </tr>

      <tr>
        <td class="half">
          <app-custom-checkbox [value]="macappsOn" [enabled]="emailNotificationsOn" [label]="getString('macapps')" (onChange)="mediaChanged($event, 'macapps')"></app-custom-checkbox>
        </td>
      </tr>

    </table>

    <div class="txt-algn-cntr">
      <div *ngIf="success" class="green-text">{{getString('settingsSaveSuccess')}}</div>
      <div *ngIf="error" class="red-text">{{getString('settingsError')}}</div>
    </div>

  </div>

  <div>
    <button class="send-button blue-button" type="button" (click)="save()">{{getString('save2')}}</button>
  </div>

</div>

<app-authentication #authentication></app-authentication>
